// extracted by mini-css-extract-plugin
export default {"ForgotPasswordForm":"tPx3X","text":"_--6qt","error":"Qka5-","button":"YAlyl","confirmPassword":"xxa0Y","letterSpam":"KR5MV","skeleton-progress":"E4yBc"};